import React from "react";

const CardIcon = ({ fill = "#2563EB" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6064 3.33331H2.93978C2.2034 3.33331 1.60645 3.93027 1.60645 4.66665V11.3333C1.60645 12.0697 2.2034 12.6666 2.93978 12.6666H13.6064C14.3428 12.6666 14.9398 12.0697 14.9398 11.3333V4.66665C14.9398 3.93027 14.3428 3.33331 13.6064 3.33331Z"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.60645 6.66669H14.9398"
        stroke={fill}
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CardIcon;
